// @ts-check
import { defineStore } from "pinia";

export const useOrderStatusesStore = defineStore("orderStatuses", {
  state: () => ({
    items: [],
    pagination: null,
    loading: false,
  }),
});
